import Papa from 'papaparse';

const expectedColumns = ['keyword', 'seller_id', 'number_of_pages', 'sort_by', 'country_id', 'schedule'];

export const buildSearchObjectsFromCsv = (text) => {
  const parsed = Papa.parse(text, {
    skipEmptyLines: true,
    transformHeader: (header) => (header || '').trim().toLowerCase(),
  });

  if (parsed.errors.length && parsed.errors.some((error) => error.code !== 'TooFewFields')) {
    console.warn('CSV parse errors:', parsed.errors);
  }

  const rows = parsed.data;
  if (rows.length === 0) {
    return [];
  }

  const firstRow = Array.isArray(rows[0]) ? rows[0] : Object.values(rows[0]);
  const headerRow = firstRow.map((cell) => String(cell || '').trim().toLowerCase());
  const headerIndexMap = {};

  expectedColumns.forEach((col) => {
    const index = headerRow.indexOf(col);
    if (index >= 0) {
      headerIndexMap[col] = index;
    }
  });

  const hasHeaderRow = Object.keys(headerIndexMap).length === expectedColumns.length;
  const dataRows = hasHeaderRow ? rows.slice(1) : rows;

  // Check if total rows exceeds 1000
  if (dataRows.length > 1000) {
    throw new Error('CSV file contains more than 1000 rows. Please reduce the number of rows and try again.');
  }

  return dataRows
    .map((row) => {
      const rowArray = Array.isArray(row) ? row : expectedColumns.map((col) => row[col] ?? '');

      // Skip rows with more columns than expected
      if (rowArray.length > expectedColumns.length) {
        return null;
      }

      const getValue = (colIndex) => {
        if (hasHeaderRow) {
          const idx = headerIndexMap[colIndex];
          return rowArray[idx] ?? '';
        }
        return rowArray[expectedColumns.indexOf(colIndex)] ?? '';
      };

      const keyword = String(getValue('keyword') || '').trim();
      const seller_id = String(getValue('seller_id') || '').trim();
      const number_of_pages = parseInt(getValue('number_of_pages'), 10);
      const sort_by = parseInt(getValue('sort_by'), 10);
      const country_id = String(getValue('country_id') || 'US').trim() || 'US';
      const scheduleRaw = String(getValue('schedule') || '').trim();
      const schedule = scheduleRaw ? parseInt(scheduleRaw, 10) : null;

      if (!keyword && !seller_id) {
        return null;
      }

      return {
        keyword: keyword || null,
        seller_id: seller_id || null,
        number_of_pages: Number.isNaN(number_of_pages) || number_of_pages < 1 ? 1 : number_of_pages,
        sort_by: Number.isNaN(sort_by) ? 12 : sort_by,
        country_id,
        schedule: Number.isNaN(schedule) ? null : schedule,
      };
    })
    .filter(Boolean);
};
